import { each } from "lodash";
import { Platform } from "@linkfluence/models/platform";
import { isPinnedAuthorCard } from "@radarly/models/cards/is";
import { FullInfluencer } from "@radarly/models/influencer";
import { isCardRow } from "@radarly/models/insight-pages/row";
import { PublicPage } from "@radarly/models/public-pages";
import { InfluencerFragment } from "@radarly/models/search";
import { InfluencerRepository } from "./InfluencerRepository";

export class PublicInfluencerRepository implements InfluencerRepository {
  private data: Record<string, FullInfluencer> = {};
  constructor(publicPage: PublicPage) {
    each(publicPage.customPage.rows, (row) => {
      if (isCardRow(row)) {
        each(row.cards, (card) => {
          if (card && isPinnedAuthorCard(card)) {
            const fragment = card.fragments[0] as InfluencerFragment;
            this.data[fragment.authorId] = fragment.data;
          }
        });
      }
    });
  }

  public async getInfluencerFromUid(
    project: number,
    influencerId: string
  ): Promise<FullInfluencer> {
    return this.data[influencerId];
  }
  public async getInfluencer(
    project: number,
    platform: Platform,
    uid: string
  ): Promise<never> {
    throw new Error("not available");
  }
}
